


























































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY as PARENT_STORE_KEY } from '../_store';
import { STORE_KEY, store } from './_store';
// @ts-ignore
import Cleave from 'cleave.js'

const cleave = {
    name: 'cleave',
    bind(el: any, binding: any) {
        const input = el.querySelector('input')
        input._vCleave = new Cleave(input, binding.value)
    },
    unbind(el: any) {
        const input = el.querySelector('input')
        input._vCleave.destroy()
    }
}

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(PARENT_STORE_KEY, [
      'document'
    ]),
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'form', 'formDirty', 'remains', 'workers',
      'asyncValidationLoading', 'hasAsyncError', 'asyncErrors', 'meta'

    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError,
    ...mapActions(STORE_KEY, [
      'addWorker', 'removeWorker'
    ])
  },
  directives: { cleave },
  validations() {
    const rules: any = {
      shift_date: { required },
      begin_time: { required },
      end_time: { required },
      times_of_day: { required },
      templates: { required },
    }

    return {
      form: rules
    }
  }
})
export default class ShiftForm extends Vue {

  document!: any
  form!: any

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    if (this.document.id) {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.document.id
      });
    } else {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.$route.query);
    }
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    if (this.$v.form[field]) {
      // @ts-ignore
      this.$v.form[field].$touch();
    }
  }

  changeWorkerValue(field: string, value: any, idx: any) {
    this.$store.dispatch(`${STORE_KEY}/changeWorkerValue`, {
      field, newValue: value, idx
    });
  }

  toggleCredentials(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/toggleCredentials`);

    if (this.$v.form.credentials) {
      // @ts-ignore
      this.$v.form.credentials.$touch();
    }

    // this.$v.form.$touch();
  }

  changeCredentialsValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeCredentialsValue`, {
      field, newValue: value
    });

    // @ts-ignore
    this.$v.form.credentials[field].$touch();
    // this.$v.form.$touch();
  }

  toggleRoleSelection(roleId: string) {
    this.$store.dispatch(`${STORE_KEY}/toggleRoleSelection`, roleId);

    if (this.$v.form.roles) {
      this.$v.form.roles.$touch();
    }

    // this.$v.form.$touch();
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, {
        id: this.document.id
      })
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('on-need-data-reload', result.document.id)
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}
